<template>
  <footer>
    <div class="footer-content">
      <div class="container_">
        <div class="row">
          <div class="col-12 col-sm-6">
            <p class="mb-0 text-muted text-medium">
              My Hotel Reputation 2018 - {{ year }} - 02 85 52 17 69
            </p>
          </div>
          <div class="col-sm-6 d-none d-sm-block">
            <ul class="breadcrumb pt-0 pe-0 mb-0 float-end">
              <li class="breadcrumb-item mb-0 text-medium">
                <a href="https://mhr.re/blog" target="_blank" class="btn-link">Le Blog</a>
              </li>
              <li class="breadcrumb-item mb-0 text-medium">
                <a href="mailto:hello@mhr.re" target="_blank" class="btn-link">hello@mhr.re</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
import moment from 'moment'

export default {
  name: 'GatheringHome',
  data() {
    return {
      year: moment().year()
    }
  }
}
</script>
